(() => {
  const validNumber = /^[A-Za-z0-9-]{6,50}$/;

  function detectCarrier(number) {
    if (/^YT[A-Za-z0-9]{8,}$/i.test(number)) return 'yunexpress';
    if (/^GFUS[A-Za-z0-9]{8,}$/i.test(number)) return 'gofo';
    if (/^UUS[A-Za-z0-9]{8,}$/i.test(number)) return 'uniuni';
    if (/^9\d{19,21}$/.test(number)) return 'usps';
    if (/^\d{12}$/.test(number)) return 'fedex';
    return null;
  }

  function trackingUrl(carrier, number) {
    const encoded = encodeURIComponent(number);
    switch (carrier) {
      case 'yunexpress':
        return `https://www.yuntrack.com/Track/Detail/${encoded}`;
      case 'usps':
        return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encoded}`;
      case 'gofo':
        return `https://www.gofo.com/us/track?searchID=${encoded}`;
      case 'uniuni':
        return `https://www.uniuni.com/tracking/#tracking-detail?no=${encoded}`;
      case 'fedex':
        return `https://www.fedex.com/fedextrack/?trknbr=${encoded}`;
      default:
        return null;
    }
  }

  function initialize(root) {
    if (root.dataset.trackingReady === 'true') return;
    const form = root.querySelector('[data-tracking-form]');
    const carrier = root.querySelector('[data-tracking-carrier]');
    const carrierField = root.querySelector('[data-tracking-carrier-field]');
    const manual = root.querySelector('[data-tracking-manual]');
    const input = root.querySelector('[data-tracking-number]');
    const error = root.querySelector('[data-tracking-error]');
    const tabs = Array.from(root.querySelectorAll('[data-tracking-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-tracking-panel]'));
    if (!form || !carrier || !carrierField || !input || !error || tabs.length !== 2 || panels.length !== 2) return;

    root.dataset.trackingReady = 'true';
    const clearError = () => {
      error.hidden = true;
      error.textContent = '';
    };
    const showError = (message) => {
      error.textContent = message;
      error.hidden = false;
    };
    const activateTab = (name, focusTab = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.trackingTab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus();
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.trackingPanel !== name;
      });
      clearError();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab.dataset.trackingTab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        activateTab(next.dataset.trackingTab, true);
      });
    });
    activateTab('number');
    input.addEventListener('input', clearError);
    carrier.addEventListener('change', clearError);
    if (manual) {
      manual.addEventListener('click', () => {
        carrierField.hidden = false;
        carrier.focus();
      });
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const number = input.value.trim().replace(/\s+/g, '');
      if (!validNumber.test(number)) {
        showError('Enter a valid tracking number using letters, numbers or hyphens.');
        input.focus();
        return;
      }
      const company = carrier.value || detectCarrier(number);
      if (!company) {
        carrierField.hidden = false;
        showError('We could not identify the carrier. Choose the carrier from your shipping email.');
        carrier.focus();
        return;
      }
      const url = trackingUrl(company, number);
      if (!url) {
        showError('This carrier is not supported. Please contact Guyker support.');
        return;
      }
      window.location.assign(url);
    });
  }

  function initializeAll(context) {
    if (context.matches && context.matches('[data-order-tracking]')) initialize(context);
    context.querySelectorAll('[data-order-tracking]').forEach(initialize);
  }

  if (window.GuykerOrderTrackingInit) {
    window.GuykerOrderTrackingInit(document);
    return;
  }
  window.GuykerOrderTrackingInit = initializeAll;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
